import { Flex } from '@chakra-ui/react';
import './index.scss';

interface MessageItemProps {
  isSystem?: boolean;
  isMe: boolean;
  children: React.ReactNode;
  msgId: string;
  cliMsgId: string;
}

export function MessageItem({ isSystem, isMe, children, msgId, cliMsgId }: MessageItemProps) {
  const preventDefault = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    e.preventDefault();
  }, []);

  const className = useMemo(() => {
    return `MessageItem ${isSystem ? 'fadeIn' : isMe ? 'slideFromRight' : 'slideFromLeft'}`;
  }, [isSystem, isMe]);

  const css = useMemo(() => {
    return {
      '--msg-item-flex-direction': isMe ? 'row-reverse' : 'row',
      '--msg-item-align-items': isMe ? 'flex-end' : 'flex-start',
      '--msg-item-justify-content': isMe ? 'flex-end' : 'flex-start',
      '--msg-item-text-align': isMe ? 'right' : 'left',
    };
  }, [isMe]);

  const onAnimationEnd = useCallback((e: React.AnimationEvent<HTMLDivElement>) => {
    (e.target as HTMLElement).classList.remove('slideFromRight', 'slideFromLeft');
  }, []);

  return (
    <Flex
      className={className}
      gap="2.5"
      css={css}
      flexDirection="var(--msg-item-flex-direction)"
      data-chat-msg-id={msgId}
      data-chat-cli-msg-id={cliMsgId}
      onContextMenu={preventDefault}
      onAnimationEnd={onAnimationEnd}
      _hover={{
        '& .MessageHeader_time': {
          display: 'inline-flex',
        },
        '& .MessageHeader_expire': {
          opacity: 1,
        },
      }}
    >
      {children}
    </Flex>
  );
}
